/**
 * @file  header/index.ts
 * @description  application header component
 *
 * @author ogarcia (ozkary)
 *
 */
import React, { Fragment, useState, useCallback, useEffect } from 'react';
import { ContentLoader } from './content';
import { HeaderModel } from './header.model';
import ListLinks from '../../elements/ListLinks';
import Image from '../../elements/Image';
import * as S from './styles';
import './styles.scss';
import { getSeller, showSeller } from '../../services/seller';
import Seller from '../../services/seller/model';

/**
 * displays the app header with logo, and menu components
 */

const Header = (): JSX.Element => {
  const [Content, setContent] = useState<HeaderModel>({} as HeaderModel);
  const [seller, setSeller] = useState<Seller | undefined>(undefined);

  const loadContent = useCallback(async () => {
    const content = (await ContentLoader).default;
    setContent(content);
  }, []);

  const loadSeller = useCallback(async () => {
    const cachedSeller = await getSeller();
    setSeller(cachedSeller);
  }, []);

  const handleSellerCacheChange = () => {
    loadSeller();
  };

  useEffect(() => {
    window.addEventListener('set-seller-cache', handleSellerCacheChange);
    return () => window.removeEventListener('set-seller-cache', handleSellerCacheChange);
  }, []);

  useEffect(() => {
    loadContent();
    loadSeller();
  }, []);

  const title = showSeller ? seller?.sellerName : '';

  return (
    <Fragment>
      <S.Div className="header__logo">
        <S.LogoContainer to="/" aria-label={Content.title}>
          <Image src={Content.image} title={Content.title} />
        </S.LogoContainer>
      </S.Div>
      <S.Div className="header__slogan">{title}</S.Div>
      <S.Div className="header__social">
        <ListLinks items={Content.menu}></ListLinks>
      </S.Div>
    </Fragment>
  );
};

export default Header;
